import { Card } from 'components/Card';
import { usePrice } from 'contexts';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { formatUsd, sumArray } from 'utils/number';
import { getPolygonTreasuryBalance } from 'utils/price';
import { Currency, CurrencyBalance } from 'utils/types';

const PolygonTreasuryTotal: React.FC = () => {
  const { t } = useTranslation();
  const [balanceMatic, setBalanceMatic] = useState({} as CurrencyBalance);
  const { maticTokenPrices } = usePrice();

  useEffect(() => {
    const fetchBalances = async () => {
      const [, nextBalanceMatic] = await getPolygonTreasuryBalance();
      setBalanceMatic(nextBalanceMatic);
    };

    fetchBalances();
  }, []);

  const maticUsd = maticTokenPrices[Currency.MATIC]?.[Currency.USD] || 0;
  const balanceTotalUsd = sumArray(Object.values(balanceMatic).map((matic) => matic * maticUsd));

  return (
    <div className="my-4">
      <Card
        title={t('polygon_treasury.title')}
        options={
          <Link className="text-xs" to="/polygon-treasury">
            {t('polygon_treasury.options_text')}
          </Link>
        }
        body={
          <>
            {formatUsd(balanceTotalUsd)}
            <span className="pl-1 text-xl text-gray-999">USD</span>
          </>
        }
        className="pb-8"
        filled
      />
    </div>
  );
};
export default PolygonTreasuryTotal;
